module.exports = __webpack_public_path__ + "img/CloudServer.8ccbbfc.svg";